
//require("./css/bootstrap-custom.css");
require('react-select/dist/default.css');
require('react-date-picker/index.css');


/** WEBPACK FOOTER **
 ** ./app/src/styles/vendor.js
 **/